<template>
  <div class="PhotoGallery">
    <div v-for="(entry, index) in content" :key="`${entry.date}-${index}`">
      <div class="PhotoGallery__Date mt-2">
        {{ formatDate(entry.date) }} ({{ `${$t("week")} ${entry.week}` }})
      </div>
      <v-row>
        <v-col
          v-for="image in entry.images"
          :key="image.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card flat @click="openInDialog(image)">
            <v-img :src="image.url" :aspect-ratio="1" cover></v-img>
          </v-card>
          <div class="py-2 PhotoGallery__Description">
            {{ image.description }}
          </div>
        </v-col>
      </v-row>
      <v-divider class="mb-8"></v-divider>
    </div>
    <v-dialog v-model="dialog">
      <v-card class="PhotoGallery__Dialog" v-if="selectedImage">
        <v-img max-height="70vh" contain :src="selectedImage.url"></v-img>
        <div class="PhotoGallery__Description">
          {{ selectedImage.description }}
        </div>
        <v-btn
          class="PhotoGallery__Button"
          absolute
          icon
          dark
          @click="dialog = false"
        >
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      selectedImage: null
    };
  },
  methods: {
    openInDialog(image) {
      this.dialog = true;
      this.selectedImage = image;
    },
    formatDate(date) {
      return moment(date).format("DD. MM. YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.PhotoGallery {
  width: 100%;
  &__Date {
    color: gray;
  }
  &__Dialog {
    padding-top: 2rem;
    position: relative;
  }
  &__Button {
    background: #fff3;
    border-radius: 0;
    border-bottom-left-radius: 1rem;
    position: absolute;
    top: 0;
    right: 0;
  }

  &__Description {
    font-size: 1rem;
    font-style: italic;
  }
}

.v-dialog {
  .PhotoGallery {
    &__Description {
      padding: 2rem;
    }
  }
}
</style>
